import { useMemo } from "react";
import { TournamentPage } from "../../types/tournamentTypes";
import { getPageDescription } from "../../util/tournamentUtils";
import { TournamentText } from "./TournamentText";

interface Props {
  page: TournamentPage;
}

/**
 * Displays the top description, which uses the bio fields
 */
export function TPageDescription(props: Props) {
  const descriptionText = useMemo(
    () => getPageDescription(props.page),
    [props.page]
  );
  return <TournamentText text={descriptionText} />;
}
